import {
  Avatar,
  Badge,
  Box,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import { useMemo } from 'react';

import {
  EmployeeItemInfoData,
  useEmployeeItemInfo,
} from '~/components/GenericList/EmployeeItemInfo/useEmployeeItemInfo';
import { getProfilePictureUrl } from '~/utils/helper';

export type EmployeeItemInfoProps = {
  employeeInfo?: EmployeeItemInfoData;
  employeeId?: number;
  variant?: 'compact' | 'full';
};

export const EmployeeItemInfo = (props: EmployeeItemInfoProps) => {
  const { employeeInfo, employeeId, variant } = props;
  const { getEmployeeItemInfoById, unknownEmployeeInfo } =
    useEmployeeItemInfo();

  // Resolve employee info if not provided
  const empInfo: EmployeeItemInfoData = useMemo(() => {
    return !!employeeInfo
      ? employeeInfo
      : !!employeeId
      ? getEmployeeItemInfoById(employeeId)
      : unknownEmployeeInfo;
  }, [employeeInfo, employeeId, unknownEmployeeInfo, getEmployeeItemInfoById]);

  const { employee, employeeUnit } = empInfo;

  // No data
  if (!employee) {
    return <></>;
  }

  return (
    <>
      <ListItemAvatar>
        <Badge>
          <Avatar src={getProfilePictureUrl(employee?.fEmpProfPictureId)} />
        </Badge>
      </ListItemAvatar>
      <ListItemText
        primary={<>{`${employee?.fEmpLastName}, ${employee?.fEmpFirstName}`}</>}
        secondary={
          <>
            <Box>{employee?.fEmpPosition}</Box>
            <Box>{`${employeeUnit?.fOrgUnitName} (${employeeUnit?.fOrgUnitNumber})`}</Box>
            {variant === 'full' && (
              <>
                <Box>{employee?.fEmpEmailWork}</Box>
                <Box>{employee?.fEmpPhoneWork}</Box>
                <Box>{employee?.fEmpPhoneMob}</Box>
              </>
            )}
          </>
        }
        slotProps={{ secondary: { component: 'div' } }}
      />
    </>
  );
};
